module.exports = __webpack_public_path__ + "img/57.c4048b36.jpg";